import React from "react";
import Popover, { Heading, Details, SearchArea } from "./Popover";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

const heavyMachinery = [
  "Crawler Excavators",
  "Wheel Excavators",
  "Dump trucks",
  "Backhoe Loaders",
  "Dozers",
  "Wheel loaders",
  "Generators",
  "Forklifts",
  "Scissor lifts",
  "Asphalt pavers",
  "Compressors",
  "Motor graders",
  "Cranes",
];

const trucks = [
  "Tractor units",
  "Concrete mixer trucks",
  "Concrete pump trucks",
  "Tipper trucks",
  "Trailers",
  "Semi Trailers",
  "Closed box trucks",
  "Vans",
];

const materialHandlingEquipment = [
  "Forklifts",
  "Reach Stackers and Container handlers",
  "Pallet Stackers",
  "Order Pickers",
  "Side loaders",
  "Rough terrain forklift",
];

function Pro() {
  return (
    <Popover
      sx={{
        "& .MuiPopover-paper": { left: "0px !important", maxWidth: "100%" },
      }}
      label="Pro"
    >
      <Heading>Explore Pro Machinery</Heading>
      <Container
        disableGutters
        sx={{
          marginTop: "28px",
          display: "flex",
          columnGap: { sm: "10px", md: "50px" },
        }}
      >
        <Details label="Heavy Machinery" content={heavyMachinery} />
        <Details label="Trucks" content={trucks} />
        <Details
          label="Material Handling Equipment"
          content={materialHandlingEquipment}
        />
        <Box
          sx={{
            width: "1px",
            minHeight: "100%",
            backgroundColor: "#BFBFBF",
          }}
        ></Box>
        <SearchArea />
      </Container>
    </Popover>
  );
}

export default Pro;
